import React from "react";

export default function SettlementPdfHeaderGrid({ headerFields }) {
  return (
    <div className="settlement-pdf-info-grid">
      {headerFields.map((field) => (
        <div className="settlement-pdf-info-row" key={field.label}>
          <div className="settlement-pdf-info-label">{field.label}</div>
          <div className="settlement-pdf-info-value">{field.value || "N/A"}</div>
        </div>
      ))}
    </div>
  );
}
